import { render, staticRenderFns } from "./KeyDocument.vue?vue&type=template&id=f0bd90c0"
import script from "./KeyDocument.vue?vue&type=script&lang=js"
export * from "./KeyDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports